export const GET_STDREQ_INDEX_DISP = 'GET_STDREQ_INDEX_DISP'
export const GET_STDREQ_COLUMNS = 'GET_STDREQ_COLUMNS'
export const GET_STDREQ_LABELS = 'GET_STDREQ_LABELS'
export const GET_STDREQ_INDEX = 'GET_STDREQ_INDEX'
export const SET_STDREQ_INDEX_DISP = 'SET_STDREQ_INDEX_DISP'
export const SET_STDREQ_COLUMNS = 'SET_STDREQ_COLUMNS'
export const SET_STDREQ_LABELS = 'SET_STDREQ_LABELS'
export const SET_STDREQ_INDEX = 'SET_STDREQ_INDEX'
export const TOGGLE_STDREQ_PAGE = 'TOGGLE_STDREQ_PAGE'
export const RECEIVED_STDREQ_COLUMNS_LABELS = 'RECEIVED_STDREQ_COLUMNS_LABELS'
export const RECEIVED_STDREQ_INDEX = 'RECEIVED_STDREQ_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/stdreq/mutation-types.js